import { useSyncExternalStore } from "react";
import {
  getNotificationStatus,
  NotificationStatus,
  readNotificationEnv,
} from "./notificationStatus";

/*
 * Stanje dozvole živi na nivou modula, a ne u svakom pozivu hooka: dozvolu menja dugme na
 * jednom mestu, a token mora da registruje hook na drugom. Svi moraju da vide isto stanje.
 * Dozvola se menja i van naše stranice (podešavanja pregledača), pa se čita ponovo kad
 * se korisnik vrati na stranicu.
 */
const read = (): NotificationStatus =>
  typeof window === "undefined"
    ? "unsupported"
    : getNotificationStatus(readNotificationEnv());

let status: NotificationStatus = read();
const listeners = new Set<() => void>();

export const refreshNotificationStatus = () => {
  const next = read();
  if (next === status) return;
  status = next;
  listeners.forEach((listener) => listener());
};

if (typeof window !== "undefined") {
  window.addEventListener("focus", refreshNotificationStatus);
  document.addEventListener("visibilitychange", refreshNotificationStatus);

  // Dozvola dozvoljena iz ikone u adresnoj traci ne vraća fokus stranici, pa je stanje
  // inače zastarelo do sledećeg povratka. Nema ga svaki pregledač; tada ostaje fokus.
  try {
    navigator.permissions
      ?.query({ name: "notifications" })
      .then((result) => {
        result.onchange = refreshNotificationStatus;
      })
      .catch(() => {});
  } catch {
    // bez Permissions API-ja
  }
}

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

/**
 * Prikazuje pregledačev prozor. Token se ne registruje ovde: kad dozvola postane
 * `granted`, to uradi `useFirebaseToken`.
 */
export const requestNotificationPermission = async () => {
  if (!("Notification" in window)) return undefined;
  const permission = await window.Notification.requestPermission();
  refreshNotificationStatus();
  return permission;
};

export const useNotificationPermission = () => {
  const current = useSyncExternalStore(subscribe, () => status);
  return { status: current, enable: requestNotificationPermission };
};
